import Vue from 'vue'
import Vuetify from 'vuetify'
import VueMoment from 'vue-moment'
import Geocoder from '@pderas/vue2-geocoder'
const moment = require('moment-timezone');
import * as VueGoogleMaps from 'vue2-google-maps'
import { Vue2Dragula } from 'vue2-dragula'
import VueQuillEditor from 'vue-quill-editor'
import wysiwyg from 'vue-wysiwyg'
import VueBreadcrumbs from 'vue2-breadcrumbs'
import VueResource from 'vue-resource'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'
import AmAngularGauge from 'amcharts3/amcharts/gauge'
import Nprogress from 'nprogress'
import VueI18n from 'vue-i18n'
import VueTour from 'vue-tour'
import fullscreen from 'vue-fullscreen'
import InstantSearch from 'vue-instantsearch'
import VueClipboard from 'vue-clipboard2'
//import VueVideoPlayer from 'vue-video-player';
import Croppa from 'vue-croppa';
import lodash from 'lodash'
import { RichMarker, RichMarkerPosition } from 'googlemaps-rich-marker-web'
// import Print from 'vue-print-nb'

// global components
import GlobalComponents from './globalComponents'

// app.vue
import App from './App'

// router
import router from './router'

// themes
import primaryTheme from './themes/primaryTheme'

// store
import { store } from './store/store'

// firebase
//import './firebase'

// include script file
import './lib/VuelyScript'

// include all css files
import './lib/VuelyCss'

// messages
import messages from './lang'

import config from './config'
import axios from 'axios'

// navigation guards before each
router.beforeEach((to, from, next) => {
    Nprogress.start()
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (store.getters.getUser === null) {
            next({
                path: '/session/login',
                query: { redirect: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})

// navigation guard after each
router.afterEach((to, from) => {
    Nprogress.done()
    setTimeout(() => {
        const contentWrapper = document.querySelector(".v-content__wrap");
        if (contentWrapper !== null) {
            contentWrapper.scrollTop = 0;
        }
        const boxedLayout = document.querySelector('.app-boxed-layout .app-content');
        if (boxedLayout !== null) {
            boxedLayout.scrollTop = 0;
        }
        const miniLayout = document.querySelector('.app-mini-layout .app-content');
        if (miniLayout !== null) {
            miniLayout.scrollTop = 0;
        }
    }, 200);
})

// plugins
Vue.use(Vuetify, {
    theme: store.getters.selectedTheme.theme
});
Vue.use(InstantSearch);
Vue.use(VueI18n)
Vue.use(AmCharts)
Vue.use(AmSerial)
Vue.use(VueTour)
Vue.use(AmAngularGauge)
Vue.use(Vue2Dragula)
Vue.use(VueQuillEditor)
Vue.use(VueResource)
Vue.use(wysiwyg, {})
Vue.use(VueBreadcrumbs)
Vue.use(Notifications, { velocity })
Vue.use(fullscreen);
Vue.use(GlobalComponents);
Vue.use(VueClipboard);
//Vue.use(VueVideoPlayer);
Vue.use(Croppa);
Vue.use(VueGoogleMaps, {
        load: {
            key: config.GOOGLE_GEOCODE_API,
            libraries: ['places', 'geometry']
        }
    })
    // Create VueI18n instance with options
const i18n = new VueI18n({
    locale: store.getters.selectedLocale.locale, // set locale
    messages, // set locale messages
})
moment.tz.setDefault('UTC')
Vue.use(VueMoment, {
    moment
})
Vue.use(Geocoder, {
    googleMapsApiKey: config.GOOGLE_GEOCODE_API
})
axios.interceptors.request.use((config) => {
    // Do something before request is sent
    if (!navigator.onLine) {
        console.log('Offline')
        store.commit('setMessage', 'You are offline. Data not saved.', { root: true })
        return
    }
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    store.commit('setLoading', true, { root: true })
    return config
}, (error) => {
    store.commit('setLoading', false, { root: true })
})

axios.interceptors.response.use((response) => {
    store.commit('setLoading', false, { root: true })
    return response
}, (err) => {
    if (err.response && err.response.config && err.response.config.url && err.response.config.url.split('/')[2] === 'wishlists') { // Wishlist will be used by both guest and users
        return
    }
    if (err.response && err.response.data && err.response.data.message) {
        store.commit('setMessage', err.response.data.message, { root: true })
    } else if (err.response && err.response.data) {
        store.commit('setMessage', err.response.data, { root: true })
        return
    } else if (err.response) {
        if (err.response.status === 401) {
            store.commit('setMessage', 'Please login to continue', { root: true })
            store.dispatch('user/logout')
            return
        } else if (err.response.status === 404) {
            store.commit('setMessage', 'Request URI Not Found', { root: true })
            return
        } else {
            store.commit('setMessage', err.response.data, { root: true })
            return
        }
    }
    return Promise.reject(err)
})

const eventHub = new Vue() // Single event hub

// Distribute to components using global mixin
Vue.mixin({
    data: () => {
        return {
            eventHub: eventHub
        }
    }
})

Vue.filter('currency', function(value) {
    return value ? '$' + parseFloat(value).toFixed(2) : '$0';
})

Vue.filter('uppercase', function (str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
})

Object.defineProperty(Vue.prototype, '_', { value: lodash })
    /* eslint-disable no-new */
new Vue({
    store,
    i18n,
    router,
    render: h => h(App),
    components: { App },
    sockets: {
        connect() {
            console.log("socket connected...")
        },
        disconnected() {
            console.log("socket disconnected...")
        }
    }
}).$mount('#app')